import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import cn from 'clsx';
import { Button, Modal, ModalHeader, Typography } from 'common/components';
import {
  creditBlockModalBtn,
  creditBlockModalText,
  creditBlockModalTextList,
  creditBlockModalTitle,
} from './credit-block-modal-styles';

type CreditBlockModalProps = {
  isOpen: boolean;
  onClose: () => void;
}

export const CreditBlockModal: React.FC<CreditBlockModalProps> = ({ isOpen, onClose }) => (
  <Modal onClose={onClose} size="m" show={isOpen}>
    <ModalHeader
      className={creditBlockModalTitle}
      title="Кредиты предоставляются банками-партнёрами и&nbsp;МФК"
    />
    <ModalContent>
      <Typography adaptive={false} className={creditBlockModalText} variant="m" size="body_long">
        Кредиты/займы без переплат* и кредиты на большие цели по низкой ставке** предоставляют следующие банки- партнеры и МФК:
      </Typography>

      <ul className={cn(creditBlockModalTextList, creditBlockModalText)}>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — АО «Кредит Европа Банк (Россия)», лицензия ЦБ РФ № 3311 от 03.09.2019 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — КБ «Ренессанс Кредит» (ООО), лицензия № 3354 от 26.04.2013 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — АО «ОТП Банк», лицензия № 2766 от 27.11.2014 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — ООО МФК «ОТП Финанс», регистрация № 651503045006297 от 16.02.2015 г.
          </Typography>
        </li>
        <li>
          <Typography adaptive={false} variant="m" size="body_long">
            — КБ «ЛОКО-Банк» (АО), лицензия № 2707 от 14.09.2015 г.
          </Typography>
        </li>
      </ul>

      <Typography adaptive={false} className={creditBlockModalText} variant="m" size="body_long">
        *Кредит/заём без переплат: при приобретении товаров в отделе “Кухни” от 80 000 рублей  с использованием кредитных средств от указанных банков-партнеров/МФК,
        ООО «ЛЕ МОНЛИД» предоставляет покупателю скидку на приобретаемый товар в размере 7.0% при сроке кредита 6 месяцев, 10,5% при сроке кредита 12 месяцев,
        в результате чего выплачиваемая покупателем сумма кредита  с учетом суммы процентов не превышает первоначальную стоимость товара,
        при условии своевременного погашения  кредита/займа  в соответствии с графиком платежей и без приобретения дополнительных услуг банков-партнеров/МФК.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        **Кредит на большие цели по низкой ставке: при приобретении товаров в отделе “Кухни” от 80 000 рублей с использованием кредитных средств от указанных банков-партнеров/МФК,
        ООО «ЛЕ МОНЛИД» предоставляет покупателю скидку 10%, в результате чего выплачиваемая покупателем сумма кредита с учетом  суммы процентов,
        превышает первоначальную стоимость товара на 3% при кредите на 12 месяцев, на 9% — на 18 месяцев, и на 15,5% — на 24 месяца,
        при условии своевременного погашения кредита/ займа в соответствии с графиком платежей и без приобретения дополнительных услуг банков-партнеров/МФК.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <Button
        adaptive={false}
        className={creditBlockModalBtn}
        href="/service/kredit/"
        target="_blank"
        title="Информация по кредитам и кредитам без переплат"
        wide
      >
        Смотреть полные условия
      </Button>
    </ModalFooter>
  </Modal>
);
